import { isRejected, isRejectedWithValue, Middleware } from "@reduxjs/toolkit";
import { actionExecution } from "../utils/appHandling";
import { setApiState } from "../slices/apiStateSlice";
import { parseError } from "../utils/errorHandling";
import { actions } from "../constants/appActions";

const errorMiddleware: Middleware = (store) => (next: any) => (action: any) => {
  if (isRejectedWithValue(action) || isRejected(action)) {
    // A query that is cancelled because the screen changed, or that never
    // started because its condition was not met, is not a failure.
    if (
      action.meta?.aborted ||
      action.meta?.condition ||
      action.error?.name === "ConditionError" ||
      action.error?.name === "AbortError"
    ) {
      return next(action);
    }

    console.error("Error:", action.error);

    // Parse the error using our standardized utility
    const errorHandler = parseError(action.payload || action.error);

    // Dispatch the error to the store
    store.dispatch(
      setApiState({
        status: errorHandler.status,
        code: errorHandler.code,
        action: errorHandler.action,
        actionType: errorHandler.actionType,
        message: errorHandler.message,
        detail: errorHandler.detail,
        showDetails: errorHandler.showDetails,
      })
    );

    actionExecution({
      action: errorHandler.action as (typeof actions)[keyof typeof actions],
      dispatch: store.dispatch,
    });
  }

  return next(action);
};

export default errorMiddleware;
